
import { Routes } from '@angular/router';
import {AdminComponent} from "./layout/admin/admin.component";
import {UserComponent} from "@white-label/layout/user/user.component";
import {PageBuilderLayoutComponent} from "@white-label/components/page-builder/page-builder-layout.component";
import {AuthGuard} from "@cybfed/core/guards/auth.guard";
import {MainComponent} from "@white-label/layout/main/main.component";
import {UnsavedChangesGuard} from "@cybfed/core/guards/unsaved-changes.guard";
import {PageBuilderComponent} from "@white-label/components/page-builder/layout/page-builder.component";
import {AdvertisingComponent} from "@white-label/layout/advertising/advertising.component";
import {RedirectComponent} from "@white-label/pages/redrect/redirect.component";
export const routes: Routes = [

  {
    path: 'page-builder',
    component: PageBuilderLayoutComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: '',
        component: PageBuilderComponent,
        canDeactivate: [UnsavedChangesGuard],
        loadChildren: () =>
            import('@white-label/components/page-builder/page-builder-routing.module')
                .then(module => module.PageBuilderRoutingModule),
      },
      {
        path: 'p/:slug',
        component: PageBuilderComponent,
        canDeactivate: [UnsavedChangesGuard],
        loadChildren: () =>
            import('@white-label/components/page-builder/page-builder-routing.module')
                .then(module => module.PageBuilderRoutingModule),
      },
    ],
  },

  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'redirect',
        component: RedirectComponent,
      },
      {
        path: '',
        component: UserComponent,
        loadChildren: () => import('./layout/user/user-routing.module').then(module => module.UserRoutingModule)
      },

      {
        path: 'admin/:whiteLabelId',
        component: AdminComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./layout/admin/admin-routing.module').then(module => module.AdminRoutingModule)
      },
    ]
  },
  {
    path: 'stream',
    component: AdvertisingComponent,
    loadChildren: () => import('./layout/advertising/advertising-routing.module').then(module => module.AdvertisingRoutingModule)
  },
]

